module.exports = __webpack_public_path__ + "static/media/55_000024.a2358113.jpg";